import Vue from 'vue'
// Moment JS
import moment from "moment";
import i18n from './i18n'
import App from './App.vue'
import router from './router'
// Buefy UI framework
import Buefy from 'buefy'
import './assets/scss/app.scss'
import "./vee-validate";
// Global Mixins
import './mixins/common'
import './mixins/messages'
import './mixins/enums'
import firebase from "firebase/app";
// Only Add the Firebase services that we use
import "firebase/auth";
import "firebase/functions";
import "firebase/storage";

moment.locale('fr')
Vue.use(Buefy)
Vue.config.productionTip = false

const firebaseConfig = {
    apiKey: "AIzaSyDerJhLTp_cAZ6xjOcVqHEk7ehLMLoPqlc",
    authDomain: "omexom-solar-panel.firebaseapp.com",
    projectId: "omexom-solar-panel",
    storageBucket: "omexom-solar-panel.appspot.com",
    messagingSenderId: "505856427338",
    appId: "1:505856427338:web:e090757c9e34ecdac8adb3",
    measurementId: "G-V2BDGGM8YJ"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

new Vue({
    i18n,
    router,
    render: h => h(App)
}).$mount('#app');
